export const calculateEligibleAmount = ({
  requestedAmount,
  annualTurnover,
}: {
  requestedAmount?: number;
  annualTurnover: number;
}): number => {
  const tenthOfTurnover = Math.round(annualTurnover / 10);

  if (!requestedAmount) {
    return tenthOfTurnover;
  }

  return Math.min(requestedAmount, tenthOfTurnover);
};
